import { render, staticRenderFns } from "./BBRadio.vue?vue&type=template&id=7fd57ad4&scoped=true"
import script from "./BBRadio.vue?vue&type=script&lang=ts"
export * from "./BBRadio.vue?vue&type=script&lang=ts"
import style0 from "./BBRadio.vue?vue&type=style&index=0&id=7fd57ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd57ad4",
  null
  
)

export default component.exports